var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomersInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4C4.10457 4 5 3.10457 5 2C5 0.89543 4.10457 0 3 0C1.89543 0 1 0.89543 1 2C1 3.10457 1.89543 4 3 4Z",
    fill: "#4F4F4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H0V7C0 6.46957 0.210712 5.96089 0.585785 5.58582C0.960858 5.21074 1.46957 5 2 5H8V7H2V12Z",
    fill: "#4F4F4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H4V12H3V18H1V10H6V18Z",
    fill: "#4F4F4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H1V12H6V6Z",
    fill: "#4F4F4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4C22.1046 4 23 3.10457 23 2C23 0.89543 22.1046 0 21 0C19.8954 0 19 0.89543 19 2C19 3.10457 19.8954 4 21 4Z",
    fill: "#4F4F4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12H22V7H16V5H22C22.5304 5 23.0391 5.21074 23.4142 5.58582C23.7893 5.96089 24 6.46957 24 7V12Z",
    fill: "#4F4F4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18H21V12H20V18H18V10H23V18Z",
    fill: "#4F4F4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6H18V12H23V6Z",
    fill: "#4F4F4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C13.1046 4 14 3.10457 14 2C14 0.89543 13.1046 0 12 0C10.8954 0 10 0.89543 10 2C10 3.10457 10.8954 4 12 4Z",
    fill: "#4F4F4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H10V18H14V6Z",
    fill: "#4F4F4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H13V7H11V11H9V7C9 6.46957 9.21071 5.96089 9.58578 5.58582C9.96086 5.21074 10.4696 5 11 5H13C13.5304 5 14.0391 5.21074 14.4142 5.58582C14.7893 5.96089 15 6.46957 15 7V11Z",
    fill: "#4F4F4D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersInactive);
export default __webpack_public_path__ + "static/media/customers-inactive.32b576336b370fbca9b159a335ede4b1.svg";
export { ForwardRef as ReactComponent };